const ScrollTo = (componentId) => {
    
    const element = document.querySelector(`#${componentId}`);
    const to = element.offsetTop;

    window.scroll({
        top: to - 100,
        behavior: "smooth"
    });

};
export default ScrollTo;




// WEBPACK FOOTER //
// ./src/helpers/scroll.js